// src/app/admin/views/company/coordinator-view/coordinator-view.component.ts

import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmEventType, ConfirmationService, Message, MessageService } from 'primeng/api';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';

@Component({
  selector: 'app-coordinator-view',
  templateUrl: './coordinator-view.component.html',
  styleUrls: ['./coordinator-view.component.scss'],
  providers: [MessageService]
})
export class CoordinatorViewComponent {

  header = this.translate('External Coordinator');
  links: link[] = [
    { name: this.translate('Back'), icon: 'pi pi-angle-right', link: '/company' },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Register External Coordinator'),  link: '/add-external-coordinator', },
  ];
  stats: stat[] = [];
  messages: Message[] = [];

  data: any[] = [];

  addTrainnerModal = false
  addCoordinatorModal = false
  updateTrainer = false
  trainerDataHolder : any
  companyID : any
  skelition = true
  trainerView =  false

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  companyData: any;
  coordinatorID : string | null = null
  fixedTrainingItemsIds: string[] = [
    '64ecbe4ff6c283d49c8f3d61',
    '64edba9b9b8555d3669790dc',
    '654e867bb9f4c5b8996191c5',
    '655b25b65316702b1f3295c1'
  ];
  dynamicTrainingItems: any = [];

  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private router: Router, 
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.coordinatorID = localStorage.getItem('uid');
    let externalData = localStorage.getItem('externalUser') 
    this.companyID =  externalData ? JSON.parse(externalData) : null
    if(this.companyID.role == 'trainer'){
      this.trainerView = true
    }
    this.getCompanyData().then(()=>{
      this.getOuType();
    })
    this.getCoordinators()
  }

  handleUpdatedUserData(data:any){
    this.updateTrainer = false
    
    this.getCompanyData();
  }

  confirmDeleteTrainer(id:string){
    this.confirm({
      message: this.translate('Are you sure you want to approve this comment?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => this.deleteTrainer(id),
    });
  }

  async deleteTrainer(id:string){
    try {
    
      let data = {
        _id : id,
        "externalUser.role" : null
      }

      let response = await this.dataService.postData('user/',data,'PUT',false)
      if(response.error){
        return
      }
      else this.getCompanyData();      
    } catch (error) {
      console.log(error)
    }
  }

  redirectToSkill(id: string){
    const params = { role: 'coordinator', id : this.coordinatorID };
    this.router.navigate(['/training/skill-training/' + id], { queryParams: params });
  }

  getOuType = async () => {
    try {
      const res = await this.dataService.postData('training-type/get/?offset=1000&page=1', {});
      if (res.error) {
        console.error('Error fetching data:', res.error);
        return;
      }
      if (res.data) {
        this.dynamicTrainingItems = res.data.filter((item: any) => this.companyData?.allowed_trainings?.includes(item._id));
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  getCompanyData = async () => {
    try {
      let res = await this.dataService.getData('company/coordinator/'+this.companyID.company);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.companyData = undefined
      this.companyData = res.data[0];
      
      

      if(this.companyData?.coordinator != this.coordinatorID){
        this.trainerView = true
      }
      
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  };

  coordinatorsData : any

  getCoordinators = async () => {
    try {
      let query = {
        'externalUser.role' : 'Coordinator',
        'externalUser.company' : this.companyID.company
      }
      let res = await this.dataService.postData('user/get', query);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.coordinatorsData = res.data
      // this.companyData = undefined
      // this.companyData = res.data[0];
      // this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  };

  deactivateInit(id:any) {
    console.log();
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-check-square',
      action: () => this.deactivateUser(id),
    });
  }

  deactivateUser = async (id : any) => {
    try {

      let deactivateData  =  {
        _id: id,
        reason: "Blocked by coordinator"
       }

      const res = await this.dataService.postData(
        `user/deactivate`,
        deactivateData,
        'PUT',
        false
      );
      if (res.error) {
        return;
      }

      
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      console.log('BEFORE EFFECT', this.data);
     
      window.location.reload()
     
    } catch (error) {
      console.log(error);
    }
  };

  UndoDeactivateUser = async (id: string) => {
    try {
      const res = await this.dataService.postData(`user/undo/deactivate/${id}`, {}, 'PUT', false);
      if (res.error) {
        this.messages = [
          { severity: 'error',  summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
     
      window.location.reload()

    } catch (error) {
      console.log(error);
    }
  };




  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }


}
